export default {
  L_AND_D_SURVEY: 'L_AND_D_SURVEY',
}
